import * as types from '../const/action.types';

export function manualProcessHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.MANUAl_PROCESS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function manualProcessIsLoading(state = false, action) {
    switch (action.type) {
        case types.MANUAl_PROCESS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function manualProcess(state = [], action) {
    switch (action.type) {
        case types.MANUAl_PROCESS_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.manual.process.reducer.js